import React from 'react'
import { Popup } from 'components/Popup'
import { MODULE_TYPES } from 'components/OmniJourney/utils'
import { getMessage } from 'lib/translator'
import './style.scss'

const SelectModuleTypePopup = ({
  setTab,
  setPopUp,
  setCurrentModule,
  setCurrentModuleIndex,
}) => {
  return (
    <Popup
      show
      heading="Select Module Type"
      close={() => setPopUp(null)}
      className="module-popup"
    >
      <div className="x4u-module-type-section">
        {MODULE_TYPES.map(({ type, text }) => (
          <button
            className="button applayout-hover-button"
            type="button"
            key={type}
            onClick={() => {
              setTab(2)
              setPopUp(null)
              setCurrentModuleIndex(null)
              setCurrentModule({
                mConfig: {
                  default: {},
                },
                mType: type,
                mIsNew: true,
                mIsEnable: false,
              })
            }}
          >
            {getMessage(text)}
          </button>
        ))}
      </div>
    </Popup>
  )
}

export default SelectModuleTypePopup
